<p-dialog
  (visibleChange)="$event ? null : cancelled.next()"
  [header]="'ti-admin.accounts.grid.launch-new-btn' | translate"
  [modal]="true"
  [visible]="opened"
  class="dialog-primary dialog-content-flex extra-large"
>
  <app-ti-account-form
    (cancelEvent)="cancelled.next()"
    (submitEvent)="launched.next($event)"
    [account]="account"
    [errorMessage]="errorMessage"
    [processing]="processing"
  ></app-ti-account-form>
</p-dialog>
